module.exports = __webpack_public_path__ + "img/-h-logo_homepage.b0fa1bba.png";